import React, { useState } from 'react'

import PropTypes from 'prop-types'
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme,
} from '@material-ui/core'

import { ConfirmationDialog, MenuButton, Permitted } from 'components'
import constants from 'constants/index'
import useSourceOrigin from 'hooks/useSourceOrigin'

import useStyles from './styles'

const ActionButtons = ({ task, onEdit, onDelete, hideDelete = false }) => {
  const classes = useStyles()
  const theme = useTheme()
  const [isDeleting, setIsDeleting] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const { hasSourceOrigin, openSourceOrigin } = useSourceOrigin()
  const canDelete = !hideDelete && !task.autoManaged

  const handleConfirmDelete = async () => {
    setConfirmOpen(false)
    setIsDeleting(true)
    try {
      await onDelete(task)
    } finally {
      setIsDeleting(false)
    }
  }

  const priorityColor =
    {
      severe: theme.palette.error.main,
      high: theme.palette.warning.main,
      medium: theme.palette.info.main,
      low: theme.palette.success.main,
    }[task.priority] || theme.palette.grey[400]

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      {isDeleting && (
        <CircularProgress size={16} className={classes.loadingIcon} />
      )}
      <MenuButton disabled={isDeleting}>
        <Button color="secondary" fullWidth onClick={() => onEdit(task)}>
          Detalhes
        </Button>
        {hasSourceOrigin(task) && (
          <Button
            color="secondary"
            fullWidth
            onClick={() => openSourceOrigin(task)}
          >
            Ver origem
          </Button>
        )}
        {canDelete && (
          <Permitted tag={constants.permissions.KANBAN_TASKS.DESTROY}>
            <Button
              color="secondary"
              fullWidth
              onClick={() => setConfirmOpen(true)}
            >
              Excluir
            </Button>
          </Permitted>
        )}
      </MenuButton>

      <ConfirmationDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        PaperProps={{
          className: classes.confirmPaper,
          style: { borderTop: `4px solid ${priorityColor}` },
        }}
        actionAcceptButton={handleConfirmDelete}
        textButton="Excluir"
        textButtonCancel="Cancelar"
        variant="primary"
        hiddenIcon
        text={
          <Box>
            <Typography variant="h4" gutterBottom>
              Você tem certeza que deseja excluir essa atividade?
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Essa ação é permanente e não poderá ser desfeita.
            </Typography>
            <Box className={classes.confirmBox}>
              <Box className={classes.confirmDot} />
              <Typography variant="body2">
                #{String(task.id).padStart(5, '0')} —{' '}
                {task.name.length > 45
                  ? task.name.slice(0, 45) + '…'
                  : task.name}
              </Typography>
            </Box>
          </Box>
        }
      />
    </Box>
  )
}

ActionButtons.propTypes = {
  task: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  hideDelete: PropTypes.bool,
}

export default ActionButtons
